import MomentTimezone from 'moment-timezone';

export const TODAY = MomentTimezone(new Date()).toDate();
export const PER_PAGE = 5; // should never be lower than paginated totalCount/totalPages
export const PAGINATION_PARAMS = { number: 1, size: PER_PAGE };
export const DEFAULT_DATE = { start: null, end: null };
export const VOLTAGE_COLUMNS_NAMES = ['Voltage Probe', 'Connection Probe', 'Phase'];
export const CURRENT_COLUMNS_NAMES = ['Current Probe', 'Feeder Name', 'Phase'];
